module.exports = __webpack_public_path__ + "img/productTxt.201ace9c.png";